// extracted by mini-css-extract-plugin
export default {"frame":"CompetitionStatus_frame__8tDfV"};